module.exports = __webpack_public_path__ + "img/higher_sphere_index.33fc017e.png";